<template>
    <v-dialog v-model="vDialogShifts" scrollable persistent max-width="1300px">
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                Possible Shifts
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-card>
                    <v-toolbar dense>
                        Order Qualifications
                    </v-toolbar>
                </v-card>
                <v-container grid-list-xs>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-center">OrderID</th>
                                <th class="text-center" colspan="3">Terminal</th>
                                <th class="text-center" colspan="2">Station</th>
                                <th class="text-center" colspan="1">Region</th>
                                <th class="text-center" v-if="ShiftsInfo.order.PumpCall">PumpCall</th>
                                <th class="text-center" v-if="ShiftsInfo.order.QuadCall">QuadCall</th>
                                <th class="text-center" v-if="ShiftsInfo.order.StraitTruck">Strait</th>
                                <th class="text-center" v-if="ShiftsInfo.order.isSpecific">Specific Product</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ ShiftsInfo.order.OrderID }}</td>
                                <td colspan="3">{{ ShiftsInfo.order.TerminalName }}</td>
                                <td colspan="2">{{ ShiftsInfo.order.StationName }}</td>
                                <td class="text-center" colspan="1">{{ ShiftsInfo.order.RegionName }}</td>
                                <td v-if="ShiftsInfo.order.PumpCall"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="ShiftsInfo.order.QuadCall"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td v-if="ShiftsInfo.order.StraitTruck"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.isSpecific"><v-icon
                                        color="success">mdi-check-circle-outline</v-icon></td>
                            </tr>
                            <tr>
                                <th class="text-center">ShiftDetail</th>
                                <th @click="setSortBy('Driver')" class="text-center">Driver</th>
                                <th @click="setSortBy('Truck')"  class="text-center">Truck</th>
                                <th @click="setSortBy('Trailer')"  class="text-center">Trailer</th>
                                <th @click="setSortBy('Yard')"  class="text-center">Yard</th>
                                <th @click="setSortBy('NewAvialable')"  class="text-center">New Aviable Time</th>
                                <th @click="setSortBy('PrincipalRegionID')"  class="text-center" colspan="1">Region</th>
                                <th @click="setSortBy('LoadCarding')"  class="text-center">Load Bagde</th>
                                <th @click="setSortBy('UnLoadCarding')" class="text-center" v-if="ShiftsInfo.order.IsTerminal">Off Load Bagde</th>
                                <th class="text-center" v-if="ShiftsInfo.order.PumpCall">PumpCall</th>
                                <th class="text-center" v-if="ShiftsInfo.order.QuadCall">QuadCall</th>
                                <th class="text-center" v-if="ShiftsInfo.order.StraitTruck">Strait</th>
                                <th class="text-center" v-if="ShiftsInfo.order.isSpecific">Specific Product</th>
                            </tr>
                            <tr v-for="ql in sortedDrivers">
                                <td class="text-center">{{ ql.ShiftDetail }}</td>
                                <td class="text-center">{{ ql.Driver }}</td>
                                <td class="text-center">{{ ql.Truck }}</td>
                                <td class="text-center">{{ ql.Trailer }}</td>
                                <td class="text-center">{{ ql.Yard }}</td>
                                <td class="text-center">{{ ql.NewAvialable }}</td>
                                <!-- <td class="text-center">{{ ql.distance_in_kilometers_yard_end }}</td>
                                    <td class="text-center">{{ ql.distance_in_kilometers_station_terminal }}</td> -->
                                <td class="text-center"><v-icon
                                        :color="ql.PrincipalRegionID == ShiftsInfo.order.Region ? 'success' : 'red'">{{
                                            ql.PrincipalRegionID == ShiftsInfo.order.Region ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center"><v-icon :color="ql.LoadCarding == true ? 'success' : 'red'">{{
                                    ql.LoadCarding == true ? 'mdi-check-circle-outline' :'mdi-close-circle'
                                        }}</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.IsTerminal > 0"><v-icon
                                        :color="ql.UnLoadCarding == true ? 'success' : 'red'">{{ ql.UnLoadCarding == true
                                            ? 'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.PumpCall"><v-icon
                                        :color="ql.PumpCall == true ? 'success' : 'red'">{{ ql.PumpCall == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.QuadCall"><v-icon
                                        :color="ql.QuadCall == true ? 'success' : 'red'">{{ ql.QuadCall == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.StraitTruck"><v-icon
                                        :color="ql.StraitTruck == true ? 'success' : 'red'">{{ ql.StraitTruck == true ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                                <td class="text-center" v-if="ShiftsInfo.order.isSpecific"><v-icon
                                        :color="ql.isSpecific == 1 ? 'success' : 'red'">{{ ql.isSpecific == 1 ?
                                        'mdi-check-circle-outline' :'mdi-close-circle' }}</v-icon></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-container>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ['ShiftsInfo', 'vDialogShifts'],
    data: function () {
        return {

            sortOrder: 'asc', // Puede ser 'asc' o 'desc'
            sortBy: 'Driver' // La propiedad por la que deseas ordenar
        }
    },
    computed: {
        sortedDrivers() {
            return this.ShiftsInfo.Shifts.sort((a, b) => {
                const isAsc = this.sortOrder === 'asc' ? 1 : -1;
                if (this.sortBy === 'NewAvialable') {
                    // Ordenar fechas
                    return isAsc * (new Date(a.NewAvialable) - new Date(b.NewAvialable));
                } else {
                    // Ordenar por otros campos (strings)
                    return isAsc * a[this.sortBy].localeCompare(b[this.sortBy]);
                }
            });
        }
    },
    mounted() {
        console.log('here', this.ShiftsInfo.order.OrderID);
    },
    methods: {
        setSortBy(field) {
            if (this.sortBy === field) {
                // Si se hace clic en el mismo campo, alternar el orden
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortBy = field;
                this.sortOrder = 'asc';
            }
        }
    }
}
</script>